import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import { watch, computed, onMounted, onUnmounted, ref, } from 'vue';
import HubList from '@V/OperationSetting/HubList.vue';
import StoreList from '@V/OperationSetting/StoreList.vue';
import { targetType } from '@/constants/operationSetting/option';
import { operationSettingActionType } from '@/vuex-store/operation-setting/actions';
import { operationSettingGetterType } from '@/vuex-store/operation-setting/getters';
import SettingDialog from '@/views/OperationSetting/SettingDialog/index.vue';
import vuexStore from '@/vuex-store';
import HistoryDialog from '@/views/OperationSetting/HistoryDialog/index.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const unSubscribe = ref();
        const isFetching = ref(true);
        const isError = ref(false);
        const isHead = computed(() => vuexStore.getters['user/isHead']);
        const isPermissionOtherHub = computed(() => vuexStore.getters['user/isPermissionOtherHub']);
        const getterSelectedHubId = computed(() => vuexStore.getters[operationSettingGetterType.getterSelectedHubId]);
        const getStoreList = async () => {
            isFetching.value = true;
            isError.value = false;
            try {
                // storeList 호출
                await vuexStore.dispatch(operationSettingActionType.getStoreList);
            }
            catch {
                isError.value = true;
            }
            isFetching.value = false;
        };
        /**
         * 허브의 운행설정이 진행되면 상점 데이터를 다시 불러올 수 있도록 스토어 구독
         */
        const subscribeStore = async () => {
            unSubscribe.value = vuexStore.subscribe(async ({ type, payload, }) => {
                if (type !== 'operationSetting/POST_OPERATION_SETTING') {
                    return;
                }
                const getterIsSelectedHubInCheckedHubList = vuexStore
                    .getters[operationSettingGetterType.getterIsSelectedHubInCheckedHubList];
                // 선택된 허브가 체크리스트에 포함되어 있으면 적용 후 상점 목록을 다시 불러온다.(허브 수정은 곧 소속된 모든 상점 수정이므로)
                if (!getterIsSelectedHubInCheckedHubList) {
                    return;
                }
                if (payload.target === targetType.STORE) {
                    return;
                }
                await getStoreList();
            });
        };
        const init = async () => {
            await Promise.all([
                (isHead.value || isPermissionOtherHub.value)
                    ? vuexStore.dispatch(operationSettingActionType.getHubList)
                    : vuexStore.dispatch(operationSettingActionType.getHubInfo),
                vuexStore.dispatch(operationSettingActionType.getStoreList),
            ]);
            await subscribeStore();
        };
        watch(() => getterSelectedHubId.value, async (v, oldValue) => {
            if (!oldValue) {
                return;
            }
            getStoreList();
        });
        onMounted(() => {
            init();
        });
        onUnmounted(() => {
            vuexStore.dispatch(operationSettingActionType.clearAllInput);
            if (unSubscribe.value === undefined) {
                return;
            }
            unSubscribe.value();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(HubList, {
                    "is-fetching": isFetching.value,
                    "is-error": isError.value
                }, null, 8 /* PROPS */, ["is-fetching", "is-error"]),
                _createVNode(StoreList, {
                    "is-fetching": isFetching.value,
                    "is-error": isError.value
                }, null, 8 /* PROPS */, ["is-fetching", "is-error"]),
                _createCommentVNode(" 설정 다이얼로그 "),
                _createVNode(SettingDialog),
                _createCommentVNode(" 운행설정 상세이력 "),
                _createVNode(HistoryDialog)
            ]));
        };
    }
});
